<!-- Komórki policzone w ngOnChanges (patrz RowCell w .ts): tekst, klasy i styl gotowe,
     bez per-komórkowych NgStyle/NgClass i wywołań formatterów w bindingach. trackCell
     po nazwie kolumny - przy przepięciu wiersza (recykling) widoki <td> zostają,
     aktualizują się tylko bindingi. -->
<ng-container *ngFor="let cell of cells; trackBy: trackCell" [ngSwitch]="cell.kind">
  <td *ngSwitchCase="'text'" [class]="cell.cls" [style]="cell.style">{{ cell.text }}</td>
  <td *ngSwitchCase="'translate'" [class]="cell.cls" [style]="cell.style">{{ cell.text | translateExt }}</td>
  <td *ngSwitchCase="'icon'" [class]="cell.cls" [style]="cell.style">
    <mat-icon svgIcon="{{ cell.column.formatterParams.icon }}"></mat-icon>
  </td>
  <td *ngSwitchCase="'iconMenu'" [class]="cell.cls" [style]="cell.style">
    <app-row-icon-menu fxLayout="row" fxLayoutAlign="start center" class="ml-2" [row]="row"
      [iconMenuCreator]="iconMenuCreator" (buttonClicked)="rowButtonClicked.emit($event)">
    </app-row-icon-menu>
  </td>
  <td *ngSwitchCase="'fillBar'" [class]="cell.cls" [style]="cell.style">
    <app-fill-bar [progress]="row | fillPipe" [negative]="cell.column.formatterParams.fillNegative"></app-fill-bar>
  </td>
  <td *ngSwitchCase="'violations-marker'" [class]="cell.cls" [style]="cell.style">
    <app-violations-marker [claims]="row?.review?.claims || {}" [claimsDate]="row?.day || null"
      (violationClicked)="handleViolationClick($event)"></app-violations-marker>
  </td>
  <td *ngSwitchCase="'violations-marker2'" [class]="cell.cls" [style]="cell.style">
    <app-violations-marker2 [claims]="row?.claims || {}" [claimsDate]="row?.day || null"></app-violations-marker2>
  </td>
  <td *ngSwitchCase="'checkbox'" [class]="cell.cls" [style]="cell.style" (click)="onCheckboxCellClicked($event, cell)">
    <mat-checkbox *ngIf="!cell.hidden" color="primary" disableRipple [checked]="cell.checked" (change)="toggleCheckbox(cell)"></mat-checkbox>
  </td>
  <td *ngSwitchCase="'jsonObject'" [class]="cell.cls" [style]="cell.style">
    <app-display-json [data]="row" [jsonPath]="cell.column?.mutatorParams?.jsonpath"></app-display-json>
  </td>

  <ng-container *ngSwitchCase="'options'">
    <ng-container *ngIf="hasMenuOptions && !optionsCellCreator; else noOptionsCell">
      <td class="options-row-cell" [class.options-row-cell--menu]="showRowNumbers" (click)="contextMenuSelected.emit({ event: $event, data: row }); $event.stopPropagation()">
        <span *ngIf="showRowNumbers" class="row-num" [style.fontSize]="rowNumberFontSize">{{ rowNumber }}</span>
        <i class="pi pi-ellipsis-v" [class.dots-icon]="showRowNumbers"></i>
      </td>
    </ng-container>
    <ng-template #noOptionsCell>
      <td *ngIf="expandableDeviceStatusRow || expandableSnvrTask; else emptyCell" class="center"
        [ngClass]="{ 'sims-blue': expanded, 'black': !expanded }">
        <i class="pi" [ngClass]="{ 'pi-chevron-right': !expanded, 'pi-chevron-down': expanded }"></i>
      </td>
      <ng-template #emptyCell>
        <td *ngIf="optionsCellCreator; else trueEmptyCell" class="options-row-cell options-cell-creator" [class.options-row-cell--menu]="showRowNumbers" (click)="$event.stopPropagation()">
          <span *ngIf="showRowNumbers" class="row-num" [style.fontSize]="rowNumberFontSize">{{ rowNumber }}</span>
          <span [class.dots-icon]="showRowNumbers">
            <app-row-icon-menu [row]="row" [iconMenuCreator]="optionsCellCreator" (buttonClicked)="rowButtonClicked.emit($event)"></app-row-icon-menu>
          </span>
        </td>
        <ng-template #trueEmptyCell>
          <td class="options-row-cell"><span *ngIf="showRowNumbers" class="row-num" [style.fontSize]="rowNumberFontSize">{{ rowNumber }}</span></td>
        </ng-template>
      </ng-template>
    </ng-template>
  </ng-container>
</ng-container>
